<div class="modal-container">
  <div class="edit-fac-container">
    <div class="inner-contant">
      <div class="edit-header">
        <svg id="return-arrow" (click)="closeModal.emit()" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.828 12.778H20V14.778H7.828L13.192 20.142L11.778 21.556L4 13.778L11.778 6L13.192 7.414L7.828 12.778Z" fill="black"/>
        </svg>            
        <span class="card-title">Origem do lead</span>
      </div>

      <div class="header-box">
        <div class="row">   
            <div id="channel-row" class="row-item">
              <p class="title">Canal</p>
              <p class="value" *ngIf="facItem.contact_type">{{facItem.contact_type}}</p>
              <p class="value" *ngIf="!facItem.contact_type">-</p>
            </div>
            <div id="origem-row" class="row-item">
              <p class="title">Origem</p>
              <p class="value" *ngIf="facItem.origin_social_network">{{facItem.origin_social_network}}</p>
              <p class="value" *ngIf="!facItem.origin_social_network">-</p>
            </div>
            <div id="midia-row" class="row-item">
              <p class="title">Mídia</p>
              <p class="value" *ngIf="facItem.channel">{{facItem.channel}}</p>
              <p class="value" *ngIf="!facItem.channel">-</p>
            </div>
        </div>
        <div class="row mr-btn">
          <div id="opportunity-row" class="row-item">
            <p class="title">Data da oportunidade</p>
            <p class="value" *ngIf="facItem.opportunity_date">{{facItem.opportunity_date | date:'dd/MM/yyyy HH:mm'}}</p>
            <p class="value" *ngIf="!facItem.opportunity_date">-</p>
          </div>
          <div id="creation-row" class="row-item">
            <p class="title">Data de criação</p>
            <p class="value" *ngIf="facItem.creation_date">{{facItem.creation_date | date:'dd/MM/yyyy HH:mm'}}</p>
            <p class="value" *ngIf="!facItem.creation_date">-</p>
          </div>
          <div id="update-row" class="row-item">
            <p class="title">Última atualização</p>
            <p class="value" *ngIf="facItem.last_update_date">{{facItem.last_update_date | date:'dd/MM/yyyy HH:mm'}}</p>
            <p class="value" *ngIf="!facItem.last_update_date">-</p>
          </div>
        </div>
      </div>

      <div class="infos-box">
        <div id="fac-row" class="infos-row" *ngIf="facItem.fac_number">
          <span class="title">Fac:&nbsp;</span>
          <span class="value"> {{facItem.fac_number}}</span>
        </div>
      </div>
      
      <!-- Pronto -->
      <div class="infos-box" *ngIf="facItem.origin_product.type && facItem.origin_product.type.toLowerCase() === 'pronto'">
        
        <div id="type-row" class="infos-row" *ngIf="facItem.origin_product.property_type">
          <span class="title">Tipo e utilização:&nbsp;</span>
          <span class="value">{{facItem.origin_product.property_type.trim()}}<span *ngIf="facItem.origin_product.property_sub_type && facItem.origin_product.property_type.toLowerCase() !== facItem.origin_product.property_sub_type.toLowerCase()">/{{facItem.origin_product.property_sub_type}}</span>
            <span *ngIf="facItem.origin_product.property_utilization">&nbsp;-&nbsp;{{facItem.origin_product.property_utilization}}</span>
          </span>
          <span class="value">&nbsp;(Ref {{facItem.origin_product.sku.substring(3)}})&nbsp;-&nbsp;</span>
          <a class="link" target="_blank" [href]="productUrl">Ficha do imóvel</a>
        </div>
        <div id="type-row" class="infos-row" *ngIf="!facItem.origin_product.property_type">
          <span class="value">(Ref {{facItem.origin_product.sku.substring(3)}})&nbsp;-&nbsp;</span>
          <a class="link" target="_blank" [href]="productUrl">Ficha do imóvel</a>
        </div>
        <div id="description-row" class="infos-row" *ngIf="facItem.origin_product.formatted_description && facItem.origin_product.property_type != 'CASA'">
          <span [innerHTML]="facItem.origin_product.formatted_description"></span>
        </div> 
        <!-- <div class="infos-row">
          <span class="title">Fila distribuída: </span>
          <span class="value"></span>
        </div>         -->
        <div id="address-row" class="infos-row" *ngIf="facItem.origin_product.address">
          <span class="title">Endereço:&nbsp;</span>
          <span class="value">
             {{facItem.origin_product.formatted_address}}
          </span>
        </div>
        <div id="product-type-row" class="infos-row">
          <span class="title">Tipo de produto:&nbsp;</span>
          <span class="value"> {{facItem.origin_product.market_type}}</span>
        </div>
        <div id="campaign-row" class="infos-row" *ngIf="facItem.campaing_text">
          <span class="title">Campanha:&nbsp;</span>
          <span class="value"> {{facItem.campaing_text}}</span>
        </div>
        <div id="link-row" class="infos-row" *ngIf="facItem.origin_product.url">
          <span class="title" > Link de origem:&nbsp; </span>
          <a class="link" style="white-space: normal; word-break: break-word;" target="_blank" href="{{facItem.origin_product.url}}">{{facItem.origin_product.url}}</a>
        </div>
      </div>

      <!-- Lançamento -->
      <div class="infos-box" *ngIf="facItem.origin_product.type && facItem.origin_product.type.toLowerCase() === 'lançamento'">
        <div id="type-row" class="infos-row" *ngIf="facItem.origin_product.property_type">
          <span class="title">Tipo:&nbsp; </span>
          <span class="value">{{facItem.origin_product.property_type}}&nbsp;</span>
          <span class="value">&nbsp;(Ref {{facItem.origin_product.sku.substring(3)}})&nbsp;-&nbsp;</span>
          <a class="link" target="_blank" [href]="productUrl">Ficha do imóvel</a>
        </div>
        <div id="type-row" class="infos-row" *ngIf="!facItem.origin_product.property_type">
          <span class="value">(Ref {{facItem.origin_product.sku.substring(3)}})&nbsp;-&nbsp;</span>
          <a class="link" target="_blank" [href]="productUrl">Ficha do imóvel</a>
        </div>
        <div id="description-row" class="infos-row" *ngIf="facItem.origin_product.formatted_description && facItem.origin_product.property_type != 'CASA'">
          <span [innerHTML]="facItem.origin_product.formatted_description"></span>
          <span *ngIf="facItem.origin_product.company_name">&nbsp;({{facItem.origin_product.company_name}})</span>
           
        </div> 
        <!-- <div id="address-row" class="infos-row" *ngIf="facItem.origin_product.address">
          <span class="title">Endereço:&nbsp; </span>
          <span class="value">
            {{facItem.origin_product.formatted_address}}
          </span>
        </div> -->
        <!-- <div class="infos-row">
          <span class="title">Fila distribuída: </span>
          <span class="value">Produtos da Região central de SP</span>
        </div> -->
        <div id="product-type-row" class="infos-row">
          <span class="title">Tipo de produto:&nbsp; </span>
          <span class="value">{{facItem.origin_product.market_type}}</span>
        </div>
        <div id="campaing-row" class="infos-row" *ngIf="facItem.campaing_text">
          <span class="title">Campanha:&nbsp; </span>
          <span class="value">{{facItem.campaing_text}}</span>
        </div>
        <div id="link-row" class="infos-row" *ngIf="facItem.origin_product.url">
          <span class="title" > Link de origem:&nbsp; </span>
          <a class="link" style="white-space: normal; word-break: break-word;" target="_blank" href="{{facItem.origin_product.url}}">{{facItem.origin_product.url}}</a>
        </div>
      </div>
  
    </div>
  </div>
</div>